import { configureStore } from '@reduxjs/toolkit';
import { newbuildingRecommendationsReducer } from '../../slices';
import { IPreloadedState } from '../../types/redux';
import { abUseExperimentsReducer } from '../../slices/abUseExperiments';
import { userReducer } from '../../slices/userReduces';
import { articleUrlReducer } from '../../slices/articleUrlReducer';
import { pathReducer } from '../../slices/pathReducer';
import { offersReducer } from '../../slices/offers';
import { commonReducer } from '../../slices/commonReducer';
import { subdomainReducer } from '../../slices/subdomainReducer';
import { flatViewOrderReducer } from '../../slices/flatViewOrder';
import { IApplicationContext } from '../../types/applicationContext';
import { flatTourBookingReducer } from '../../slices/flatTourBookingReducer';
import { aerialViewReducer } from '../../slices/aerialView';
import { realtyValuationReducer } from '../../slices/realtyValuation';
import { promoInfoReducer } from '../../slices/promoInfo';
import { floorPlanReducer } from '../../slices/floorPlanReducer';
import { builderChatReducer } from '../../slices/builderChat';
import { chatOnboardingReducer } from '../../slices/chatOnboarding';
import { blackFridayReducer } from '../../slices/blackFriday';
import { newbuildingReducer } from '../../slices/newbuildingReducer';
import { builderLinkReducer } from '../../slices/builderLinkReducer';
import { reliabilityV2Reducer } from '../../slices/reliabilityV2Reducer';
import { reliabilityReducer } from '../../slices/reliabilityReducer';
import { fullUrlReducer } from '../../slices/fullUrlReducer';
import { settingsReducer } from '../../slices/settingsReducer';

/**
 * Хелпер для создания Redux стора
 * @param preloadedState TApplicationState - предзагруженное состояние
 */

export function createReduxStore(preloadedState: IPreloadedState, context: IApplicationContext, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      abUseExperiments: abUseExperimentsReducer,
      aerialView: aerialViewReducer,
      articleUrl: articleUrlReducer,
      blackFriday: blackFridayReducer,
      builderChat: builderChatReducer,
      chatOnboarding: chatOnboardingReducer,
      common: commonReducer,
      flatTourBookingState: flatTourBookingReducer,
      flatViewOrder: flatViewOrderReducer,
      floorPlan: floorPlanReducer,
      newbuildingRecommendations: newbuildingRecommendationsReducer,
      newbuilding: newbuildingReducer,
      offers: offersReducer,
      path: pathReducer,
      promoInfo: promoInfoReducer,
      realtyValuation: realtyValuationReducer,
      subdomain: subdomainReducer,
      userState: userReducer,
      isBuilderLinkEnabled: builderLinkReducer,
      isReliabilityV2Enabled: reliabilityV2Reducer,
      reliabilityState: reliabilityReducer,
      fullUrl: fullUrlReducer,
      settings: settingsReducer,
    },
  });
}
